import { getProjects } from '@/api/project-manage/project';
import './index.less';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Skeleton, Table } from 'antd';
import { ReactComponent as AddSvg } from '../icons/add.svg';
import { ReactComponent as SearchSvg } from '../icons/search.svg';
import TnInput from '@/global/components/input/tn-input';
import CreateProjectModal from '@/global/components/create-project-modal';
import { Project } from '@/global/interface/project-manage/project';
import { getMonitorTypeLabel } from '@/enums/monitor-type';
import dayjs from 'dayjs';
import TnMessage from '@/global/components/message';
import localStore from '@/global/store/local-store';


export default function ProjectListPanel() {
    const navigate = useNavigate();
    const [projects, setProjects] = useState<Project[]>([]); // 项目
    const [displayProjects, setDisplayProjects] = useState<Project[]>([]); // 展示项目
    const [showModal, setShowModal] = useState<boolean>(false); // 显示添加项目弹窗
    const [loading, setLoading] = useState<boolean>(false); // loading
    const [searchStr, setSearchStr] = useState<string>(''); // 搜索框值

    useEffect(() => {
        generateData();
    }, [])

    useEffect(() => {
        let newDisplay = projects?.filter(item => item.name.toLowerCase().includes(searchStr)) || [];
        setDisplayProjects(newDisplay);
    }, [searchStr])

    const generateData = () => {
        if (!localStore?.userId) return;
        setLoading(true);
        getProjects({ userId: localStore?.userId }).then(res => {
            let data = res.data || [];
            setProjects(data);
            setDisplayProjects(data);
        }).catch(err => {
            TnMessage.error("获取项目失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    const onRowClick = (row) => {
        let elem = document.documentElement;
        if (!document.fullscreenElement && elem?.requestFullscreen) {
            elem?.requestFullscreen();
        }
        navigate(`/screen/project/${row.id}/`)
    }


    return (
        <div className='project-list-panel'>
            <div className='project-header'>
                <div className="create-project-btn" onClick={() => setShowModal(true)}>
                    <AddSvg />
                    创建项目
                </div>
                <TnInput
                    value={searchStr}
                    prefix={<SearchSvg />}
                    style={{ width: 240 }}
                    placeholder='搜索项目名称'
                    onTextChange={(e) => setSearchStr(e)}
                    allowClear
                />
            </div>
            <div className="project-table-area">
                <Table
                    rowKey="id"
                    pagination={false}
                    dataSource={displayProjects || []}
                    bordered={false}
                    className='tn-project-table'
                    onRow={row => {
                        return {
                            onClick: () => { onRowClick(row) },
                        }
                    }}
                    rowClassName={_ => 'project-table-row'}
                    sticky
                    loading={loading}
                >
                    <Table.Column dataIndex="name" title="项目名称" width={`${5 / 15 * 100}%`} ellipsis />
                    <Table.Column dataIndex="leaderName" title="负责人" ellipsis width={`${2 / 15 * 100}%`} />
                    <Table.Column dataIndex="monitorRank" title="监测等级" width={`${2 / 15 * 100}%`}
                        render={(value: number, row: any, idx) => {
                            let text = '';
                            let color = '';
                            let backgroundColor = ''
                            if (value === 1) {
                                text = '一级';
                                color = '#E71111';
                                backgroundColor = 'rgba(231, 17, 17, 0.10)';
                            } else if (value === 2) {
                                text = '二级';
                                color = '#ED7B13';
                                backgroundColor = 'rgba(237, 123, 19, 0.10)';
                            } else if (value === 3) {
                                text = '三级';
                                color = '#DBAD0A';
                                backgroundColor = 'rgba(255, 208, 40, 0.10)';
                            }
                            return (
                                <div style={{
                                    borderRadius: 4,
                                    color: color,
                                    backgroundColor: backgroundColor,
                                    width: 48,
                                    height: 28,
                                    textAlign: 'center',
                                    fontSize: 16,
                                    lineHeight: '28px',
                                }}>{text}</div>
                            )
                        }}
                    />
                    <Table.Column dataIndex="monitorType" title="监测类别" width={`${2 / 15 * 100}%`}
                        render={(value: number, row: any, idx) => <div>{getMonitorTypeLabel(value)}</div>}
                    />
                    <Table.Column dataIndex="startTime" title="状态" width={`${4 / 15 * 100}%`}
                        render={(value: number, row: any, idx) => {
                            let text = '';
                            let color = '';
                            let periodInMilliseconds = row?.period * 24 * 60 * 60 * 1000;
                            let elapsedTime = dayjs().valueOf() - value;
                            if (elapsedTime > periodInMilliseconds) {
                                text = '关闭';
                                color = '#626262';
                            } else {
                                text = '执行中';
                                color = '#2469EF';
                            }

                            return (
                                <div style={{
                                    color: color,
                                    fontSize: 16,
                                    lineHeight: '28px',
                                }}>{text}</div>
                            )
                        }}
                    />
                </Table>
            </div>

            {showModal && <CreateProjectModal
                showModal={showModal}
                setShowModal={setShowModal}
                onSuccess={() => {
                    generateData();
                    setShowModal(false);
                }}
            />}
        </div>
    )
}